import { createAction, handleActions } from "redux-actions";

//#region Actions
const actionScope = "PRACTICE_SESSION_";
export const practiceSessionRequestFail = createAction(actionScope + "REQUEST_FAIL");

export const loadPracticeODMRequest = createAction(actionScope + "LOAD_PRACTICE_ODM_REQUEST");
export const loadPracticeODMSuccess = createAction(actionScope + "LOAD_PRACTICE_ODM_SUCCESS");

export const setPracticeODMRequest = createAction(actionScope + "SET_PRACTICE_ODM_REQUEST");
export const setPracticeODMSuccess = createAction(actionScope + "SET_PRACTICE_ODM_SUCCESS");

export const updatePracticeRequest = createAction(actionScope + "UPDATE_PRACTICE_REQUEST");
export const updatePracticeSuccess = createAction(actionScope + "UPDATE_PRACTICE_SUCCESS");

export const deletePracticeRequest = createAction(actionScope + "DELETE_PRACTICE_REQUEST");
export const deletePracticeSuccess = createAction(actionScope + "DELETE_PRACTICE_SUCCESS");

export const loadRelatedPatientsRequest = createAction(
  actionScope + "LOAD_RELATED_PATIENTS_REQUEST"
);
export const loadRelatedPatientsSuccess = createAction(
  actionScope + "LOAD_RELATED_PATIENTS_SUCCESS"
);

export const updatePracticePatientRequest = createAction(
  actionScope + "UPDATE_PRACTICE_PATIENT_REQUEST"
);
export const updatePracticePatientSuccess = createAction(
  actionScope + "UPDATE_PRACTICE_PATIENT_SUCCESS"
);

export const deletePracticePatientRequest = createAction(
  actionScope + "DELETE_PRACTICE_PATIENT_REQUEST"
);
export const deletePracticePatientSuccess = createAction(
  actionScope + "DELETE_PRACTICE_PATIENT_SUCCESS"
);

export const loadRelatedPartnersRequest = createAction(
  actionScope + "LOAD_RELATED_PARTNERS_REQUEST"
);
export const loadRelatedPartnersSuccess = createAction(
  actionScope + "LOAD_RELATED_PARTNERS_SUCCESS"
);

export const updatePracticePartnerRequest = createAction(
  actionScope + "UPDATE_PRACTICE_PARTNER_REQUEST"
);
export const updatePracticePartnerSuccess = createAction(
  actionScope + "UPDATE_PRACTICE_PARTNER_SUCCESS"
);

export const deletePracticePartnerRequest = createAction(
  actionScope + "DELETE_PRACTICE_PARTNER_REQUEST"
);
export const deletePracticePartnerSuccess = createAction(
  actionScope + "DELETE_PRACTICE_PARTNER_SUCCESS"
);

export const loadRelatedProvidersRequest = createAction(
  actionScope + "LOAD_RELATED_PROVIDERS_REQUEST"
);
export const loadRelatedProvidersSuccess = createAction(
  actionScope + "LOAD_RELATED_PROVIDERS_SUCCESS"
);

export const updatePracticeProviderRequest = createAction(
  actionScope + "UPDATE_PRACTICE_PROVIDER_REQUEST"
);
export const updatePracticeProviderSuccess = createAction(
  actionScope + "UPDATE_PRACTICE_PROVIDER_SUCCESS"
);

export const deletePracticeProviderRequest = createAction(
  actionScope + "DELETE_PRACTICE_PROVIDER_REQUEST"
);
export const deletePracticeProviderSuccess = createAction(
  actionScope + "DELETE_PRACTICE_PROVIDER_SUCCESS"
);

export const loadRelatedConversationConfigurationsRequest = createAction(
  actionScope + "LOAD_CONVERSTATION_CONFIGURATIONS_REQUEST"
);
export const loadRelatedConversationConfigurationsSuccess = createAction(
  actionScope + "LOAD_CONVERSTATION_CONFIGURATIONS_SUCCESS"
);

export const associateConversationConfigurationsRequest = createAction(
  actionScope + "ASSOCIATE_CONVERSTATION_CONFIGURATION_REQUEST"
);
export const associateConversationConfigurationsSuccess = createAction(
  actionScope + "ASSOCIATE_CONVERSTATION_CONFIGURATION_SUCCESS"
);

export const removeConversationConfigurationRequest = createAction(
  actionScope + "REMOVE_CONVERSTATION_CONFIGURATION_REQUEST"
);
export const removeConversationConfigurationSuccess = createAction(
  actionScope + "REMOVE_CONVERSTATION_CONFIGURATION_SUCCESS"
);
//#endregion

//Selectors
export const practiceODMSelector = state => state.practiceSession.practiceODM;

export const relatedPatientODMsSelector = state => state.practiceSession.relatedPatientODMs;
export const relatedPartnerODMsSelector = state => state.practiceSession.relatedPartnerODMs;
export const relatedProviderODMsSelector = state => state.practiceSession.relatedProviderODMs;
export const relatedConversationConfigurationODMsSelector = state =>
  state.practiceSession.relatedConversationConfigurationODMs;

//State Object
const initialState = {
  //these members use the omnDataModel defined by the JSON in this project
  practiceODM: null,

  relatedPatientODMs: null, //self documenting verbosity, excuse the perspicacity
  relatedPartnerODMs: null, //self documenting verbosity, excuse the perspicacity
  relatedProviderODMs: null, //self documenting verbosity, excuse the perspicacity

  relatedConversationConfigurationODMs: null, //self documenting verbosity, excuse the perspicacity
};

//Reducers
export default handleActions(
  {
    [practiceSessionRequestFail]: state => state,

    [loadPracticeODMRequest]: state => state,
    [loadPracticeODMSuccess]: (state, { payload }) => ({
      ...state,
      practiceODM: payload,
    }),

    [setPracticeODMRequest]: state => state,
    [setPracticeODMSuccess]: (state, { payload }) => ({
      ...state,
      practiceODM: payload,
    }),

    [updatePracticeRequest]: state => state,
    [updatePracticeSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [deletePracticeRequest]: state => state,
    [deletePracticeSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [loadRelatedPatientsRequest]: state => state,
    [loadRelatedPatientsSuccess]: (state, { payload }) => ({
      ...state,
      relatedPatientODMs: payload,
    }),

    [updatePracticePatientRequest]: state => state,
    [updatePracticePatientSuccess]: (state, { payload }) => ({
      ...state,
      relatedPatientODMs: payload,
    }),

    [deletePracticePatientRequest]: state => state,
    [deletePracticePatientSuccess]: (state, { payload }) => ({
      ...state,
      relatedPatientODMs: payload,
    }),

    [loadRelatedPartnersRequest]: state => state,
    [loadRelatedPartnersSuccess]: (state, { payload }) => ({
      ...state,
      relatedPartnerODMs: payload,
    }),

    [updatePracticePartnerRequest]: state => state,
    [updatePracticePartnerSuccess]: (state, { payload }) => ({
      ...state,
      relatedPartnerODMs: payload,
    }),

    [deletePracticePartnerRequest]: state => state,
    [deletePracticePartnerSuccess]: (state, { payload }) => ({
      ...state,
      relatedPartnerODMs: payload,
    }),

    [loadRelatedProvidersRequest]: state => state,
    [loadRelatedProvidersSuccess]: (state, { payload }) => ({
      ...state,
      relatedProviderODMs: payload,
    }),

    [updatePracticeProviderRequest]: state => state,
    [updatePracticeProviderSuccess]: (state, { payload }) => ({
      ...state,
      relatedProviderODMs: payload,
    }),

    [deletePracticeProviderRequest]: state => state,
    [deletePracticeProviderSuccess]: (state, { payload }) => ({
      ...state,
      relatedProviderODMs: payload,
    }),

    [loadRelatedConversationConfigurationsRequest]: state => state,
    [loadRelatedConversationConfigurationsSuccess]: (state, { payload }) => ({
      ...state,
      relatedConversationConfigurationODMs: payload,
    }),

    [associateConversationConfigurationsRequest]: state => state,
    [associateConversationConfigurationsSuccess]: state => ({
      ...state,
    }),

    [removeConversationConfigurationRequest]: state => state,
    [removeConversationConfigurationSuccess]: state => ({
      ...state,
    }),
  },
  initialState
);
